document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener("cf:ready", function () {
        const checkboxes = document.querySelectorAll('input[name="accepts_marketing"]');
        checkboxes.forEach(function (checkbox) {
            checkbox.removeAttribute("autocomplete"); // autocomplete attribute should not be used on <input type="checkbox">
        
            const labelSpan = checkbox.parentElement.querySelector('[id="440673label"]');
            if (labelSpan) {
                labelSpan.removeAttribute("aria-hidden");
                labelSpan.classList.add("sr-only");
                labelSpan.textContent = "Subscribe to marketing emails";
            }
        })
    });

    // To add accessible labels for inputs in cf_hidden_forms
    function applyAccessibleLabels() {
      const inputMap = [
        { selector: 'input[name="customer[email]"]', label: 'Email' },
        { selector: 'input[name="customer[password]"]', label: 'Password' },
        { selector: 'input[name="return_to"]', label: 'Return To' },
        { selector: 'input[name="email"]', label: 'Recovery Email' },
        { selector: 'input[name="form_type"]', label: 'Form Type' }
      ];

      inputMap.forEach(({ selector, label }) => {
        document.querySelectorAll('#cf_hidden_forms ' + selector).forEach((input) => {
          if (!input.hasAttribute('aria-label')) {
            input.setAttribute('aria-label', label);
          }
        });
      });
    }

    // Wait until the form exists
    const waitForHiddenForms = setInterval(() => {
      const hiddenFormsExist = document.querySelector('#cf_hidden_forms input');
      if (hiddenFormsExist) {
        clearInterval(waitForHiddenForms);
        applyAccessibleLabels();
      }
    }, 100);

    // To add proper accessible label for fs_cuid input
    waitForElements('.cf-field-container.hidden', function (elements) {
        elements.forEach(el => {
            el.querySelectorAll('input[name="fs_cuid"]').forEach(fsCuidInput => {
                if (fsCuidInput) {
                    fsCuidInput.removeAttribute('aria-labelledby');
                    fsCuidInput.setAttribute('aria-label', 'Customer Unique ID');
                }
            });
        });
    })

    // To add alt text for spacer images
    waitForElements('img[style*="display: none"]', function (imageElements) {
        imageElements.forEach(imageElement => {
            if (!imageElement.getAttribute('alt')) {
              imageElement.setAttribute('alt', '');
            }
        })
    });



    // Watch for dynamic elements being added
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            // Handle hidden images.
            // if (node.tagName.toLowerCase() === 'img' && window.getComputedStyle(node).display === 'none') {
            //     node.setAttribute('alt', '');
            // }
            const matches = node.querySelectorAll('input.yotpo-filter-select');
            matches.forEach(function (yotpoScoreDropdownInput) {
                yotpoScoreDropdownInput.setAttribute('role', 'combobox');
                const yotpoScoreDropdownLabel = document.querySelector(`label[for="${yotpoScoreDropdownInput.id}"]`);
                yotpoScoreDropdownLabel.setAttribute('id', yotpoScoreDropdownInput.getAttribute('aria-labelledby'));
            });

            const yotpoReviewsPaginationNav = node.querySelector('nav.yotpo-reviews-pagination-container');
            if (yotpoReviewsPaginationNav) {
                yotpoReviewsPaginationNav.setAttribute('aria-label', 'Yotpo reviews pagination navigation')
            }

            // To add accessible label for h-captcha-response(textarea input)
            const hCaptchaResponseInput = node.querySelector('textarea[name="h-captcha-response"]');
            if (hCaptchaResponseInput) {
                hCaptchaResponseInput.setAttribute('aria-label', 'Captcha Response')
            }
            
          }
        });
      });
    });

    // Start observing the DOM for dynamically added content
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
});

  /**
   * Waits for an element to appear in the DOM before running a callback
   */
  function waitForElement(selector, callback) {
    const interval = setInterval(() => {
      const el = document.querySelector(selector);
      if (el) {
        clearInterval(interval);
        callback(el);
      }
    }, 100);
  }

  /**
   * Waits for elements to appear in the DOM before running a callback
   */
  function waitForElements(selector, callback) {
      const interval = setInterval(() => {
        const elements = document.querySelectorAll(selector);
        if (elements.length > 0) {
          clearInterval(interval);
          callback(elements);
        }
      }, 100);
  }